/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface ProductPurchaseControllerSearchByAdmin$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 사용자 ID
 */
  userId?: string | null;

/**
 * 센터 ID
 */
  centerId?: string | null;

/**
 * 상품 ID
 */
  productId?: string | null;

/**
 * 다운로드 가능 여부
 */
  download?: ('enabled' | 'disabled') | null;
}

export function productPurchaseControllerSearchByAdmin(http: HttpClient, rootUrl: string, params: ProductPurchaseControllerSearchByAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, productPurchaseControllerSearchByAdmin.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('userId', params.userId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('productId', params.productId, {});
    rb.query('download', params.download, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto>;
    })
  );
}

productPurchaseControllerSearchByAdmin.PATH = '/api/product-purchase/admin';
